var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n4"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      staticClass: "pa-4",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "disabled": !item.tooltip,
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var attrs = _ref.attrs,
            on = _ref.on;
          return [_c('v-chip', _vm._g(_vm._b({}, 'v-chip', Object.assign({}, attrs, item), false), on), [_vm._v(" " + _vm._s(item.text) + " ")])];
        }
      }], null, true)
    }, [!!item.tooltip ? [_c('div', {
      staticClass: "item-badge__tooltip"
    }, [_vm._v(" " + _vm._s(item.tooltip) + " ")])] : _vm._e()], 2)], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }